import { forwardRef, type InputHTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

export type InputProps = InputHTMLAttributes<HTMLInputElement>;

export const Input = forwardRef<HTMLInputElement, InputProps>(({ className, ...props }, ref) => (
  <input
    ref={ref}
    className={cn(
      'h-10 w-full rounded-xl border border-gray-800 bg-gray-900 text-white px-3 text-sm placeholder:text-gray-500 transition-colors',
      'focus-visible:outline-none focus-visible:border-gold focus-visible:ring-2 focus-visible:ring-gold/30',
      'disabled:opacity-50',
      className,
    )}
    {...props}
  />
));
Input.displayName = 'Input';
